<template>
    <div class="context">
        <component :is="componentId"
                   @changeTopTab="switchModule"
                   :ref="componentId"></component>
    </div>
</template>

<script>
    import tableView from "./tableView"
    import illView from "./ill"
    // import warnView from "./warning"

    export default {
        name: "",
        components: {
            tableView,
            illView,
            // warnView,
        },
        data() {
            return {
                componentId: 'tableView'
            }
        },
        methods: {
            switchModule(id) {
                this.componentId = id
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
</style>